import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { HomeComponent } from "./pages/home/vta.home.component";
import {
  LoginComponent,
  AuthLayoutComponent,
  RegisterComponent,
  LogoutComponent,
  RequestPasswordComponent,
  ResetPasswordComponent,
} from "./@theme/components/auth/public_api";
import { VerifyUserComponent } from "./@theme/components/auth/components/verify-user/vta.verify-user.component";
import { ApproveRequestComponent } from "./@theme/components/auth/components/approve-request/vta.approve-request.component";
import { PrivacyPolicyComponent } from "./privacy-policy/vta.privacy-policy.component";
import { TermsAndConditionsComponent } from "./terms-and-conditions/vta.terms-and-conditions.component";
import { VerifyEmailComponent } from "./@theme/components/auth/components/verify-email/vta.verify-email.component";

export const routes: Routes = [
  {
    path: "pages",
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
  },
  // Home page — standalone (has its own navbar + footer)
  { path: "", component: HomeComponent, pathMatch: "full" },
  { path: "home", component: HomeComponent },
  // Auth pages — wrapped in AuthLayoutComponent (shared header + footer)
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "register",
        component: RegisterComponent,
      },
      {
        path: "logout",
        component: LogoutComponent,
      },
      {
        path: "request-password",
        component: RequestPasswordComponent,
      },
      {
        path: "resetpassword",
        component: ResetPasswordComponent,
      },
      {
        path: "verify",
        component: VerifyUserComponent,
      },
      {
        path: "verifyEmail",
        component: VerifyEmailComponent,
      },
      {
        path: "approve",
        component: ApproveRequestComponent,
      },
      {
        path: "view",
        component: ApproveRequestComponent,
      },
      {
        path: "privacy-policy",
        component: PrivacyPolicyComponent,
      },
      {
        path: "terms-and-conditions",
        component: TermsAndConditionsComponent,
      },
    ],
  },
  { path: "**", redirectTo: "pages" },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
